import React from "react"
// import './WebsiteDesigning.css'

import websiteDesigning from '../../assets/bannerImages/websiteDevelopment.jpg'

import customDesign from '../../assets/images/customDesign.jpg'
import latestTechnology from '../../assets/images/latestTechnology.jpg'
import ongoingSupport from '../../assets/images/ongoingSupport.jpg'

import discoveryAndPlanning from '../../assets/images/discoveryAndPlanning.jpg'
import designAndDevelopment from '../../assets/images/designingAndDevelopment.jpg'
import testingAndLaunch from '../../assets/images/testingAndLaunch.jpg'

// import googleadsLogo from '../../assets/logos/googleadsLogo.jpg'
// import metaadsLogo from '../../assets/logos/metaadsLogo.jpg'
// import microsoftadsLogo from '../../assets/logos/microsoftadsLogo.jpg'
// import linkedinLogo from '../../assets/logos/linkedinLogo.jpg'
import { Link } from "react-router-dom"


export default function WebsiteDesigning(){
    return(
        <div className="websiteDesigning">
            <WDR1/>
            <WDR2/>
            <WDR3/>
            <WDR4/>
            <ContactSection/>
            {/* this contact section's css is in social media marketing page's css file */}
        </div>
    )
}

function WDR1(){
    return(
        <div className='wdr1'>
            <img loading="lazy" src={websiteDesigning} alt='wd-banner' className='wd-banner-img'/>
            <h1 className='wdr1-head'>Website Designing</h1>
            <div className='overlay'></div>
        </div>
    )
}

function WDR2(){
    return(
        <div className='wdr2'>
            <div className='strip'>
                <h1>What Is <span>Website Designing</span>?</h1>
                <hr/>   
                <p>Website designing is the process of creating and arranging the visual elements and user experience of a website. 
                    It involves planning and building the structure, layout, colors, fonts, and graphics to make the site visually appealing and easy to navigate. 
                    Effective website design ensures that visitors can find information quickly and enjoy a seamless, engaging online experience.</p>
            </div>
        </div>
    )
}

function WDR3(){
    return(
        <div className='wdr3'>
            <div className='rowThreeContainer'>
                <h1 className='rowThreeHead'>
                Why <span>Choose Bixian</span> for Website Designing?
                </h1>
                <p className='rowThreeContext'>
                At Bixian, we specialize in crafting visually stunning and highly functional websites tailored to meet your unique business needs. 
                Our team of expert designers and developers are dedicated to providing a seamless user experience, ensuring your website not only looks great but also performs flawlessly. 
                With a focus on innovation, creativity, and client satisfaction, we deliver websites that help your business stand out in the digital landscape.
                </p>
                <div className='rowThreeBoxes'>
                    {/* box 1 */}
                    <div className='box boxOne'>
                        <div className='context'>
                            <img loading="lazy" src={customDesign} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Custom Designs
                            </h2>
                            <p className='boxPara'>
                            We create unique website designs that reflect your brand and meet your specific goals, ensuring a strong online presence.
                            </p>
                        </div>
                    </div>
                    {/* box 2 */}
                    <div className='box boxTwo'>
                        <div className='context'>
                            <img loading="lazy" src={latestTechnology} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Latest Technology
                            </h2>
                            <p className='boxPara'>
                            Our use of modern technologies guarantees a responsive, optimized website that works smoothly on all devices.
                            </p>
                        </div>
                    </div>
                    {/* box 3 */}
                    <div className='box boxThree'>
                        <div className='context'>
                            <img loading="lazy" src={ongoingSupport} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Ongoing Support
                            </h2>
                            <p className='boxPara'>
                            We offer continuous support and maintenance to keep your website updated and performing at its best.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

function WDR4(){
    return(
        <div className='wdr4'>
            <div className='rowFourContainer'>
                <div className='rowFourContext'>
                    <h1 className='rowFourHead'>Our Process</h1>
                    <p className='rowFourPara'>
                    At Bixian, our website designing process is structured to ensure we deliver results that align with your business goals. From understanding your requirements to launching a fully functional website, our systematic approach ensures efficiency, creativity, and attention to detail at every stage.
                    </p>
                </div>
                <div className='rowFourBoxes'>
                    <div className='box boxOne'>
                            <img loading="lazy" src={discoveryAndPlanning} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Discovery and Planning</h2>
                        <p className='boxPara'>We conduct research and discussions to understand your business needs and target audience. This helps us create a solid foundation and clear roadmap for the project.</p>
                    </div>
                    <div className='box boxTwo'>
                            <img loading="lazy" src={designAndDevelopment} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Design and Development</h2>
                        <p className='boxPara'>Our designers create mockups reflecting your brand identity. Once approved, our developers build the website using the latest technologies, ensuring it is responsive and user-friendly.</p>
                    </div>
                    <div className='box boxThree'>
                            <img loading="lazy" src={testingAndLaunch} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Testing and Launch</h2>
                        <p className='boxPara'> We rigorously test the website for functionality and performance. After ensuring everything meets our high standards, we launch the website, making it live and accessible to your audience.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

function ContactSection(){
    return(
        <div className="contactSection">
                <div className="box">
                    <div className="context">
                        <h1>Wanna Discuss More About Our Website Designing?</h1>
                        <p>Schedule a free consultation and esitmate with our expert.</p>
                    </div>
                    <div className="buttonHolder">
                        <Link to='/contact'><button>Get A Free Estimation</button></Link>
                    </div>
                </div>
            </div>
    )
}